import React from 'react'
import { useSelector } from 'react-redux'
import SiteDetailsTemplate from '../contentPages/SiteDetailsTemplate'

const SiteDetails = () => {
	const userLogin = useSelector(state => state.userLogin)
	const { userInfo } = userLogin
	// TODO: Create skeleton loader

	return <SiteDetailsTemplate user={userInfo} />
}
export default SiteDetails
